import React from 'react'
import { ChevronUp } from 'lucide-react'

interface Props {
  workOrderId: string
  technicianName: string | null
  workDateTime: { date: string; time: string } | null
  canSave: boolean
  isPending: boolean
  mode: 'create' | 'edit'
  collisionError?: boolean
    backendError?: string | null
  onOpenModal: () => void
  onSave: () => void
  onCancel: () => void
}

export const DraftAppointmentBar: React.FC<Props> = ({
  workOrderId,
  technicianName,
  workDateTime,
  canSave,
  isPending,
  mode,
  collisionError = false,
  onOpenModal,
  onSave,
  onCancel,
  backendError
}) => {
  const saveLabel = mode === 'edit' ? 'Aktualisieren' : 'Speichern'
  const savingLabel = mode === 'edit' ? 'Aktualisieren...' : 'Speichern...'

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg">
      <div className="flex items-center justify-between px-8 py-3">
        <div className="flex items-center gap-6 text-sm">
          <span className="text-slate-500">
            Auftrag: <span className="font-medium text-slate-900">{workOrderId}</span>
          </span>
          <span className="text-slate-500">
            Techniker: <span className="font-medium text-slate-900">{technicianName ?? '—'}</span>
          </span>
          {workDateTime && (
            <span className="text-slate-500">
              {workDateTime.date} <span className="font-medium text-slate-900">{workDateTime.time}</span>
            </span>
          )}
        </div>
  {backendError && (
          <p className="col-span-4 text-sm text-red-500 font-medium">{backendError}</p>
        )}
        <div className="flex items-center gap-3">
          {collisionError && (
            <span className="text-sm text-red-500 font-medium">
              Zeitüberschneidung – nicht speicherbar
            </span>
          )}
          <button
            type="button"
            onClick={onOpenModal}
            className="p-1.5 rounded hover:bg-slate-100 transition-colors text-slate-500"
            title="Details bearbeiten"
          >
            <ChevronUp size={18} />
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={isPending}
            className="px-5 py-2 rounded-[40px] border border-slate-300 text-slate-600 font-['Roboto'] text-[15px] font-medium hover:bg-slate-50 transition-colors disabled:opacity-50"
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={isPending || !canSave}
            className="px-5 py-2 rounded-[40px] bg-[#124093] text-white font-['Roboto'] text-[15px] font-medium hover:brightness-110 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isPending ? savingLabel : saveLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
